import * as esFoodParser from './esFoodParser';
import {makeAPICall} from './/Util';
const FATSECRET_API_KEY = process.env.REACT_APP_FATSECRET_API_KEY;
const FATSECRET_API_SECRET = process.env.REACT_APP_FATSECRET_API_SECRET;
// Using forked version of the fatsecret npm package so we can use cors proxy (otherwise, FS limits to just 1 domain).
// FUTURE: Investigate another way to get around the FS cors limitation?
const fatAPI = new (require('../lib/fatsecret'))(FATSECRET_API_KEY, FATSECRET_API_SECRET);
let _ = require('lodash');

export const SOURCE_NAME_FOOD = esFoodParser.SOURCE_NAME.FS_Food;
export const SOURCE_NAME_RECIPE = esFoodParser.SOURCE_NAME.FS_Recipe;
let lastInitiatedQueries = {}
lastInitiatedQueries[SOURCE_NAME_FOOD] = '';
lastInitiatedQueries[SOURCE_NAME_RECIPE] = '';

// doc: https://platform.fatsecret.com/api/Default.aspx?screen=rapiref&method=foods.search
export function searchFoods(query, maxResults, callback) {
  console.log("calling /food/fatSecret");
  lastInitiatedQueries[SOURCE_NAME_FOOD] = query;
  makeAPICall('/food/fatSecret', {
    type: 'food',
    query: query,
    maxResults: maxResults
  }, (body) => {
    if (lastInitiatedQueries[SOURCE_NAME_FOOD] && lastInitiatedQueries[SOURCE_NAME_FOOD] === query) { // Ignore outdated queries
      lastInitiatedQueries[SOURCE_NAME_FOOD] = '';
      if (body.error) {
        callback({error: body.error});
      } else {
        callback(body.foods);
      }
    }
  }, (err) => {
    callback({error: err.message});
  });
}

// doc: https://platform.fatsecret.com/api/Default.aspx?screen=rapiref&method=foods.search
export function searchRecipes(query, maxResults, callback) {
  lastInitiatedQueries[SOURCE_NAME_RECIPE] = query;
  makeAPICall('/food/fatSecret', {
    type: 'recipe',
    query: query,
    maxResults: maxResults
  }, (body) => {
    if (lastInitiatedQueries[SOURCE_NAME_RECIPE] && lastInitiatedQueries[SOURCE_NAME_RECIPE] === query) { // Ignore outdated queries
      lastInitiatedQueries[SOURCE_NAME_RECIPE] = '';
      if (body.error) {
        callback({error: body.error});
      } else {
        callback(body.recipes /*could be null*/);
      }
    }
  }, (err) => {
    callback({error: err.message});
  });
}

// Convert to a standardized form that's consumable by FoodLoggingForm.js
// Currently this is the elasticsearch returned hit format because that just happened to get implemented first.
// FUTUREl: In the future, we should standardize this to something simpler?
// FUTURE: Also refactor this to a helper when we start adding other API support
export function convertToElasticsearchHit(foodInfo, sourceName) {
  let hit = null;
  if (!foodInfo) {
    return hit;
  }

  if (sourceName === SOURCE_NAME_FOOD) {
    hit = {
      _id: `${SOURCE_NAME_FOOD}_${foodInfo.food_id}`,
      _source: {
        name: foodInfo.food_name,
        sources: [sourceName],
        servings: []
      }
    };

    if (foodInfo.brand_name) {
      hit._source.brandName = foodInfo.brand_name;
    }

    let servingObj = foodInfo.servings.serving;
    if (_.isArray(servingObj)) {
      for (let i = 0; i < servingObj.length; i++) {
        let servingInfo = servingObj[i];
        let sourceObj = {
          sourceName: sourceName,
          sourceItemId: foodInfo.food_id,
          url: foodInfo.food_url
        };
        addServingToHit(hit, servingInfo, sourceObj);
      }
    } else {
      let servingInfo = servingObj;
      let sourceObj = {
        sourceName: sourceName,
        sourceItemId: foodInfo.food_id
      };
      addServingToHit(hit, servingInfo, sourceObj);
    }
  } else if (sourceName === SOURCE_NAME_RECIPE) {
    let recipeName = foodInfo.recipe_name;
    hit = {
      _id: `${SOURCE_NAME_FOOD}_${foodInfo.recipe_id}`,
      _source: {
        name: recipeName,
        sources: [sourceName],
        servings: []
      }
    };

    hit._source.brandName = 'FatSecret Recipes';

    let servingInfo = foodInfo.serving_sizes.serving;
    // I think servingInfo.serving_size is always '1 serving' for recipes?
    let servingDescription = servingInfo.serving_size;
    servingInfo.serving_description = servingDescription;
    let sourceObj = {
      sourceName: sourceName,
      sourceItemId: foodInfo.recipe_id,
      url: foodInfo.recipe_url
    };
    addServingToHit(hit, servingInfo, sourceObj);
  }
  return hit;
}

function addServingToHit(hit, servingInfo, sourceObj) {
  let nutritionData = esFoodParser.createNutritionDataObject(
    servingInfo.calories, servingInfo.carbohydrate, servingInfo.fat, servingInfo.protein, servingInfo.fiber, servingInfo.sugar
  )
  let servingItem = {
    name: servingInfo.serving_description,
    nutritionData: nutritionData,
    source: sourceObj
  };
  hit._source.servings.push(servingItem);
}


// WEBPACK FOOTER //
// ./src/helpers/FatSecret.js